import { apiPost } from "../ApiMethod";
import { setFirmwareData } from "../../mappers";

export const createFirmware = async (data) => {
  const response = await apiPost("_firmware", data);
  return { ...response, data: setFirmwareData(response.data) };
};
